import { ConsentString } from 'consent-string';

/**
 * This function checks if a given consent string allows for analytics purposes based on the
 * IAB Transparency and Consent Framework (TCF).
 *
 * @param {string} consentString - The consent string compliant with TCF.
 * @returns {boolean} - Returns true if the measurement purpose (purpose 17) is allowed, false otherwise.
 */
export function getAnalyticsConsent(consentString: string): boolean {
  const consentData = new ConsentString(consentString);
  const measurementPurpose = 17;

  return !!consentData
    .getPurposesAllowed()
    .find((purpose) => purpose === measurementPurpose);
}
